@if (mode$ | async; as mode) {
  <div class="flex flex-col items-center">
    @switch (mode) {
      @case (action.ResetPassword) {
        @if (!isSubmitting) {
          @if (userEmail$ | async; as userEmail) {
            <div>
              <pr-password-form
                #resetPasswordForm="prPasswordForm"
                (submitted)="resetPassword($event)"
              >
                <h2>Reset password for {{ userEmail }}</h2>
              </pr-password-form>
              <button
                mat-flat-button
                color="primary"
                [disabled]="resetPasswordForm.form.invalid"
                (click)="resetPassword(resetPasswordForm.form.value)"
              >
                Submit
              </button>
            </div>
          }
        } @else {
          <ng-container *ngTemplateOutlet="loader" />
        }
      }

      @case (action.SignInEmailLink) {
        @if (!isSubmitting) {
          <div class="flex w-80 flex-col items-center gap-4">
            @if (isNewUser) {
              <pr-password-form
                #newUserPasswordForm="prPasswordForm"
                (submitted)="setPassword($event)"
              >
                <h2>Please set a password</h2>
              </pr-password-form>
              <button
                mat-flat-button
                color="primary"
                [disabled]="newUserPasswordForm.form.invalid"
                (click)="setPassword(newUserPasswordForm.form.value)"
              >
                Submit
              </button>
            } @else {
              <h2>Please verify your email</h2>
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="email"
                  [formControl]="emailControl"
                  [required]="true"
                />
              </mat-form-field>
              <button
                mat-flat-button
                color="primary"
                [disabled]="emailControl.invalid"
                (click)="signInWithEmailLink(emailControl.value)"
              >
                Submit
              </button>
            }
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loader" />
        }
      }

      @default {
        <ng-container *ngTemplateOutlet="loader" />
      }
    }

    <ng-template #loader>
      <div class="flex flex-col items-center gap-4">
        <mat-spinner [diameter]="64" />
        <p>Activating Account</p>
      </div>
    </ng-template>
  </div>
}
